import { EntityCategories } from '@npco/mp-gql-types'

export const getCategoryFromString = (category: string) => {
  return (EntityCategories as any)[category] as EntityCategories | undefined
}
